<template>
  <div class="container_box">
    <!--新增模板-->
    <Button type="primary" @click="addSupplierLevelBtn" style="margin: 5px 0 10px 0;"
      v-if="getPermission('ymsSupplierMerchantGrade_create')">{{ $t('key1002714') }}</Button>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        :loading="tableLoading"
        :columns="tableColumns"
        max-height="700"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="curPage"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--供应商等级弹窗-->
    <Modal v-model="supplierLevelModal" class-name="supplierLevelStyle" :title="supplierLevelTitle" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="supplierLevelModalChange">
      <Form ref="supplierLevelForm" :model="supplierLevelForm" :rules="ruleValidate" :label-width="120"
        :disabled="supplierLevelTalg === 'look'" @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002723')" prop="name">
              <Input clearable v-model.trim="supplierLevelForm.name" style="width: 80%;"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002724')" prop="distributorType">
              <RadioGroup v-model="supplierLevelForm.distributorType">
                <Radio label="all">{{ $t('key1002718') }}</Radio>
                <Radio label="part">{{ $t('key1002725') }}</Radio>
              </RadioGroup>
            </Form-item>
            <div class="distributor_list" v-show="supplierLevelForm.distributorType === 'part'">
              <CheckboxGroup v-model="distributorlevelArr">
                <Checkbox v-for="(item, index) in distributorlevelList" :key="index"
                  :label="item.ymsDistributorMerchantGradeId">{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </div>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <div style="text-align: center;">
          <Button @click="supplierLevelModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="supplierLevelBtn"
            v-if="supplierLevelTalg === 'add' || supplierLevelTalg === 'edit'">
            {{ $t('key1000111') }}
          </Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';


import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {getCustomerLevelAll} from "@/utils/common";

export default {
  name: "supplierLevel",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      supplierLevelModal: false,
      supplierLevelTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002714'),
      supplierLevelTalg: 'add',
      ymsSupplierMerchantGradeId: null,
      distributorlevelList: [],
      distributorlevelArr: [],
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      curPage: 1,
      supplierLevelForm: {
        name: '',
        distributorType: 'all',
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002715'),
            trigger: 'blur'
          }
        ]
      },
      tableData: [],
      tableColumns: [
        {
          title: 'NO.',
          key: 'index',
          width: 80,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002716'),
          key: 'name',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002717'),
          key: 'validDistributorMerchantGradeName',
          align: 'center',
          minWidth: 250,
          render(h, params) {
            let list = '';
            let name = params.row.validDistributorMerchantGradeIds;
            if (name) {
              if (name === 'ALL') {
                list = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002718');
              } else {
                let arr = name.split(',');
                let nameList = [];
                v.distributorlevelList.map((item) => {
                  if (arr.includes(item.ymsDistributorMerchantGradeId)) {
                    nameList.push(item.name);
                  }
                });
                list = nameList.join('、');
              }
            }
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show:  v.getPermission('ymsSupplierMerchantGrade_detail'),
                    clickFn: () => {
                      v.getLevelDetails(params.row.ymsSupplierMerchantGradeId, 'look');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsSupplierMerchantGrade_update'),
                    clickFn: () => {
                      v.getLevelDetails(params.row.ymsSupplierMerchantGradeId, 'edit');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsSupplierMerchantGrade_delete'),
                    clickFn: () => {
                      v.deleteSupplierLevelBtn(params.row.ymsSupplierMerchantGradeId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ]
    };
  },
  created() {
    // 获取分销商等级所有数据
    getCustomerLevelAll().then((data) => {
      this.distributorlevelList = this.handleMultilinguaTableFields(data, ['name']);
    });
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      let v = this;
      if (v.getPermission('ymsSupplierMerchantGrade_query')) {
        v.tableLoading = true;
        let params = Object.assign({}, v.pageParams);
        v.axios.post(api.post_ymsSupplierMerchantGrade_query, params).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新增供应商等级
    addSupplierLevelBtn() {
      this.supplierLevelModal = true;
      this.supplierLevelTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002714');
      this.supplierLevelTalg = 'add';
    },
    // 获取供应商等级详情
    getLevelDetails(ymsSupplierMerchantGradeId, type) {
      this.ymsSupplierMerchantGradeId = ymsSupplierMerchantGradeId;
      this.axios.get(api.get_ymsSupplierMerchantGrade + ymsSupplierMerchantGradeId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          this.supplierLevelForm.name = data.name;
          if (data.validDistributorMerchantGradeIds) {
            if (data.validDistributorMerchantGradeIds === 'ALL') {
              this.supplierLevelForm.distributorType = 'all';
              this.distributorlevelArr = [];
            } else {
              this.supplierLevelForm.distributorType = 'part';
              this.distributorlevelArr = (data.validDistributorMerchantGradeIds).split(',');
            }
          }
          if (type === 'look') {
            this.supplierLevelTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002719');
            this.supplierLevelTalg = 'look';
          } else {
            this.supplierLevelTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002720');
            this.supplierLevelTalg = 'edit';
          }
          this.supplierLevelModal = true;
        }
      });
    },
    // 删除供应商等级
    deleteSupplierLevelBtn(ymsSupplierMerchantGradeId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002721'),
        onOk: () => {
          v.axios.delete(api.delete_ymsSupplierMerchantGrade + `${ymsSupplierMerchantGradeId}`).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 新增、编辑供应商等级确定按钮
    supplierLevelBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      let obj = {};
      if (v.supplierLevelForm.distributorType === 'all') {
        obj.validDistributorMerchantGradeIds = ['ALL'];
      } else {
        if (v.distributorlevelArr.length > 0) {
          obj.validDistributorMerchantGradeIds = v.distributorlevelArr;
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002722'));
          return false;
        }
      }
      // 新增供应商等级
      if (v.supplierLevelTalg === 'add') {
        url = api.post_ymsSupplierMerchantGrade_create;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
        obj.name = v.supplierLevelForm.name;
      }
      // 编辑分销商
      else if (v.supplierLevelTalg === 'edit') {
        url = api.put_ymsSupplierMerchantGrade_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        obj.name = v.supplierLevelForm.name;
        obj.ymsSupplierMerchantGradeId = v.ymsSupplierMerchantGradeId;
      }
      v.$refs.supplierLevelForm.validate((valid) => {
        if (valid) {
          let query = {
            method: method,  // 请求的方法
            url: url,  // 接口
            data: obj  // 参数
          };
          v.axios(query).then(response => {
            if (response.data.code === 0) {
              v.supplierLevelModal = false;
              v.$Message.success(text);
              v.getList();
            }
          });
        }
      });
    },
    // 监听供应商等级弹窗(关闭弹窗重置数据)
    supplierLevelModalChange(value) {
      if (!value) {
        this.$refs['supplierLevelForm'].resetFields();
        this.supplierLevelTalg = 'look';
        this.supplierLevelForm.distributorType = 'all';
        this.distributorlevelArr = [];
        this.distributorsTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002719');
        this.ymsSupplierMerchantGradeId = null;
      }
    },
  },
  watch: {
    // 监听切换被展示分销商
    supplierLevelForm: {
      handler(value) {
        let v = this;
        if (value.distributorType === 'all') {
          v.distributorlevelArr = [];
        }
      },
      deep: true
    },
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  /deep/ .supplierLevelStyle {
    .distributor_list {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      top: -15px;
      padding: 0 0 0 123px;

      .ivu-checkbox-wrapper {
        margin: 0 25px 5px 0;
      }
    }
  }
}
</style>
